import React, {useState} from 'react';
import {FormControl} from '@material-ui/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import cn from 'classnames';
import {useDispatch, useSelector} from 'react-redux';
import TabPanel from 'components/shared/TabPanel';
import SelectWrapper from 'components/select/SelectComponentStyles';
import {DashboardInner} from 'components/DashboardInner/styles';
import {DashboardField, DashboardFields} from 'routes/App/dashboard/styles';
import Subtitle from 'components/typography/Subtitle1';
import {
  FullRefundContainer,
  FullRefundItem,
  FullRefundItems,
  RCTabs
} from 'routes/App/Managers/RefundsCalculator/styles';
import Body5 from 'components/typography/Body5';
import Subtitle5 from 'components/typography/Subtitle5';

import {
  RC_CLEAR_CALCULATOR_DATA,
  RC_GENERATE_ORDER_REIMBURSEMENT,
  RC_SET_REIMBURSEMENT_RESPONSIBILITY,
  RC_OPEN_REIMBURSEMENT_CONFIRMATION_MODAL,
  RC_SET_LOCATION_REVERSE_AMOUNT
} from 'store/refundsCalculator/action';
import {ErrorSign, ErrorSignWrapper} from 'components/errorSign/errorSign';
import {ButtonPrimary} from 'components/buttons';
import ConfirmationReimbursementModal from 'routes/App/Managers/RefundsCalculator/Components/Modals/ConfirmationReimbursementModal';
import Loading from 'components/shared/Utils/Loading';
import {REFUND_TYPES} from 'helpers/constants/refundCalculator';
import ReimbursementFixedAmount from 'routes/App/Managers/RefundsCalculator/Components/ReimbursementTabs/ReimbursementFixedAmount';
import PartialReimbursement from 'routes/App/Managers/RefundsCalculator/Components/ReimbursementTabs/PartialReimbursement';

const RCReimbursement = () => {
  const dispatch = useDispatch();
  const {
    reimbursementAmount,
    reimbursementResponsibility,
    orderData,
    openConfirmationReimbursementModal,
    loading,
    resultLoading,
    deniedRefundTypes
  } = useSelector((state) => state.refundsCalculator);
  const [valueTabs, setValueTabs] = useState(null);
  const [selectError, setSelectError] = useState(null);

  const handleChangeTabs = (event, newValue) => {
    if (reimbursementResponsibility !== -1) {
      setValueTabs(newValue);
      if (valueTabs !== newValue) {
        dispatch(RC_CLEAR_CALCULATOR_DATA());
      }
      if (newValue === 0) {
        dispatch(RC_GENERATE_ORDER_REIMBURSEMENT(newValue));
      }
    } else {
      setSelectError('Mandatory field');
    }
  };

  const handleChangeSelect = (event) => {
    setSelectError(null);
    dispatch(RC_SET_REIMBURSEMENT_RESPONSIBILITY(event.target.value));

    if (event.target.value && [0, 1, 2].includes(event.target.value)) {
      if (valueTabs !== null && valueTabs !== 2) {
        dispatch(RC_SET_LOCATION_REVERSE_AMOUNT(null));
        dispatch(RC_GENERATE_ORDER_REIMBURSEMENT(valueTabs));
      }
    } else {
      setValueTabs(null);
    }
  };

  return (
    <>
      {loading ? (
        <DashboardInner className='RefundsCalculator withoutShadow paddingLg'>
          <Loading />
        </DashboardInner>
      ) : (
        <DashboardInner className='RefundsCalculator withoutShadow paddingLg'>
          <DashboardFields className='noWrapDesktop AlignCenter marginMinus'>
            <DashboardField className='wAuto'>
              <Subtitle>
                Responsible for reimbursement <span>*</span>
              </Subtitle>
            </DashboardField>
            <DashboardField className='wAutoSpace width220'>
              <SelectWrapper className='SelectMd w100'>
                <FormControl className='select-formcontrol'>
                  <Select
                    className={cn({
                      error: selectError
                    })}
                    value={reimbursementResponsibility}
                    name='reimbursementResponsibility'
                    onChange={handleChangeSelect}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left'
                      },
                      transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left'
                      },
                      getContentAnchorEl: null
                    }}
                  >
                    <MenuItem value={-1}>Select</MenuItem>
                    <MenuItem value={0}>Sauce</MenuItem>
                    {orderData?.orderType !== 'Pickup' && (
                      <MenuItem value={1}>Delivery company</MenuItem>
                    )}
                  </Select>
                </FormControl>
              </SelectWrapper>
              <ErrorSignWrapper>
                <ErrorSign className='colorRed'>
                  {!!selectError && selectError}
                </ErrorSign>
              </ErrorSignWrapper>
            </DashboardField>
          </DashboardFields>
          <RCTabs>
            <Tabs value={valueTabs} onChange={handleChangeTabs} elevation={0}>
              <Tab
                className={cn('reinversment', {
                  disabled: deniedRefundTypes?.includes(REFUND_TYPES.Full)
                })}
                label='Reimburse Subtotal'
              />
              <Tab
                className={cn('reinversment', {
                  disabled: deniedRefundTypes?.includes(REFUND_TYPES.Partial)
                })}
                label='Reimburse Items'
              />
              <Tab
                className={cn('reinversment', {
                  disabled: deniedRefundTypes?.includes(
                    REFUND_TYPES.FixedAmount
                  )
                })}
                label='Fixed Amount'
              />
            </Tabs>
          </RCTabs>
          <TabPanel value={valueTabs} index={0} />
          <TabPanel value={valueTabs} index={1}>
            <PartialReimbursement
              typeValue={valueTabs}
              setFaultError={setSelectError}
            />
          </TabPanel>
          <TabPanel value={valueTabs} index={2}>
            <ReimbursementFixedAmount
              typeValue={valueTabs}
              setFaultError={setSelectError}
            />
          </TabPanel>
          {valueTabs !== null && (
            <>
              <FullRefundContainer>
                <FullRefundItems>
                  <FullRefundItem>
                    <Body5 className='FullRefundTitle'>
                      B2B Reimbursement is
                    </Body5>
                    <Subtitle5 className='FullRefundPrice marginLeftXsPlus'>
                      {resultLoading ? (
                        <Loading className='RefundCalculator' />
                      ) : (
                        <>$ {Number(reimbursementAmount || 0).toFixed(2)}</>
                      )}
                    </Subtitle5>
                  </FullRefundItem>
                </FullRefundItems>
              </FullRefundContainer>
              <DashboardField className='wAuto justifyCenter'>
                <ButtonPrimary
                  className={cn('ButtonMakeRefund', {
                    disabled:
                      !reimbursementAmount ||
                      loading ||
                      reimbursementResponsibility === -1
                  })}
                  onClick={() =>
                    dispatch(RC_OPEN_REIMBURSEMENT_CONFIRMATION_MODAL(true))
                  }
                >
                  <span>Reimburse B2B</span>
                </ButtonPrimary>
              </DashboardField>
            </>
          )}
          <ConfirmationReimbursementModal
            openModal={openConfirmationReimbursementModal}
            refundType={valueTabs}
          />
        </DashboardInner>
      )}
    </>
  );
};

export default RCReimbursement;
